import $ from 'jquery';
import select2 from 'select2';
import datepickerFactory from 'jquery-datepicker';
// import datepickerJAFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-ja';
import './imports/chatgpt.js';

import tippy from 'tippy.js';

select2($);

datepickerFactory($);
// datepickerJAFactory($);

tippy('[data-tippy-content]');

$(function() {

  /**
   * Mobile menu
   */
  
  $('.menu-toggle').on('click', function() {
    $('.nav--header').slideToggle(500);
  });

  if ($(window).width() < 640) {
    $('.has-children').hover(function() {
      $('.submenu').slideToggle(500);
    });
  }

  /**
   * [ Create/edit Patient Report ]
   * 
   * Filter dropdowns
   */

  $('[data-filter]').on('change', function() {

    $('.save_favourite', $(this).parents('.form__group')).prop('checked', false);
    $('.confirm_content, .create_content', $(this).parents('.form__group')).hide();

    var tax = $(this).data('filter'),
        filter_to = $(this).data('filter-to'),
        val = $(this).val(),
        post_type = $(this).data('post-type'),
        allow_new = $(this).data('allow-new'),
        current_user_id = $('[name="current_user_id"]').val();

    $.ajax({
      type: 'POST',
      url: ajaxurl,      
      dataType: 'json',
      data: {
        action : 'filter_posts',
        tax : tax,
        val : val,
        post_type : post_type
      },
      success: function(response) {

        var select = $('#' + filter_to);

        if (response.length > 0)
        {

          var default_option = $('option:first', select);

          select.empty(); select.append(default_option);

          for (var i = 0; i < response.length; i++) { 

            if (response[i].post_author == current_user_id && allow_new === true)
            {
              var usercreated = true;
            }
            else
            {
              var usercreated = false;
            }

            select.append('<option value="' + response[i].ID + '" data-usercreated="' + usercreated + '" data-favourite="' + response[i].user_favourite + '">' + response[i].post_title + '</option>');

          }

          if (allow_new === true)
          {

            select.append('<option value="create_content">Type a new one...</option>');

          }

          select.prop('selectedIndex', 0);
          select.trigger('change'); // Trigger change to update selected value

        } else {

          select.empty();
          select.append('<option value="create_content">Type a new one...</option>');
          select.trigger('change');

        }

      }
    });

  });   

  /**
   * [ Create/edit Patient Report ]
   * 
   * Second level dropdowns
   */
  
  $('[data-append-to]').on('change', function(e) {

    // Not triggered by manual selection; return false

    if (e.isTrigger === 3) return false;

    $('.confirm_content, .create_content', $(this).parents('.form__group')).hide();
    $('.save_favourite', $(this).parents('.form__group')).prop('checked', false);

    var val = $(this).val(),
        cat = $('[data-filter]', $(this).parents('.col')).val();

    if (val == 'create_content')
    {

      if (cat !== null)
      {
        $('.create_content', $(this).parents('.col')).show();
      } 
      else 
      {
        alert('Please first select a category');
      }

    }
    else
    {

    if ($(this).find(':selected').data('favourite') === true)
    {
      $('.save_favourite', $(this).parents('.form__group')).prop('checked', true);
    }

    // Show editing box after selection to allow changes
    
    $('.create_content', $(this).parents('.col')).show();
    var $title = $('[name="new_content_title"]', $(this).parents('.col'));
    var $textarea = $('[name="new_content"]', $(this).parents('.col'));
    var $submit = $('[data-action="createcontent"]', $(this).parents('.col'));
    var $deletebtn = $('[data-action="deletecontent"]', $(this).parents('.col'));

    $submit.data('postid', val);
    $deletebtn.data('postid', val).show();

    if ($(this).find(':selected').data('usercreated') === true)
    {
      $deletebtn.show();
    }
    else
    {
      $deletebtn.hide();
    }

    $.ajax({
      type: 'POST',
      url: ajaxurl,      
      dataType: 'json',
      data: {
        action : 'get_post_content',
        post_id : val
      },
      success: function(response) {
          var title = $.trim( response.post_title );
          var value  = $.trim( response.post_content );

          $title.val(title);
          $textarea.val(value);

          $('.create_content', $(this).parents('.form__group')).show();

      }
  });

  }

  });

  $('[data-action="confirmcontent"]').on('click', function(e) {

    var $scope = $('[data-append-to]', $(this).parents('.form__group'));
    var $filter = $('[data-filter]', $(this).parents('.form__group'));

    var cpt = $scope.data('filter-leveltwo'),
        append_to = $scope.data('append-to'),
        val = $scope.val(),
        cat = $('[data-filter]', $scope.parents('.col')).val(),
        save_favourite = $('.save_favourite', $(this).parents('.form__group')).prop('checked');


    $.ajax({
      type: 'POST',
      url: ajaxurl,      
      dataType: 'json',
      data: {
        action : 'get_post_content',
        post_id : val,
        save_favourite : save_favourite
      },
      success: function(response) {
          var value  = $.trim( response.post_content ),
              $field = $('#' + append_to + '_text'),
              ed = tinymce.get(append_to + '_text');

          ed.selection.select(ed.getBody(), true);
          ed.selection.collapse(false);
          ed.execCommand('mceInsertContent', false, '<p>' + value.replace(/\n/g,"<br>") + '</p>');

          // Refresh data to update favourite status

          $filter.trigger('change');

      }
    });

  });

  /**
   * [ Create/edit Patient Report ]
   * 
   * Create second level content
   */

  $('[data-action="createcontent"]').click(function(e) { 

    e.preventDefault();

    var cpt = $(this).data('cpt'),
        title = $(this).siblings('[name="new_content_title"]').val(),
        content = $(this).prev('[name="new_content"]').val(),
        tax = $('[data-filter]', $(this).parents('.col')).data('filter'),
        cat = $('[data-filter]', $(this).parents('.col')).val(),
        append_to = $('[data-append-to]', $(this).parents('.col')).data('append-to'),
        postid = $(this).data('postid'),
        save_favourite = $('.save_favourite', $(this).parents('.create_content')).prop('checked'),
        filter = $('[data-filter]', $(this).parents('.col'));

    $.ajax({
      type: 'POST',
      url: ajaxurl,      
      dataType: 'json',
      data: {
        action : 'add_report_content',
        cpt : cpt,
        cat : cat,
        tax : tax,
        title : title,
        content : content,
        postid : postid,
        save_favourite : save_favourite
      },
      success: function(response) {

        var value  = $.trim( response.post_content ),
            $field = $('#' + append_to + '_text'),
            ed = tinymce.get(append_to + '_text');

        ed.selection.select(ed.getBody(), true);
        ed.selection.collapse(false);
        ed.execCommand('mceInsertContent', false, '<p>' + value.replace(/\n/g,"<br>") + '</p>');

        $('.create_content').hide();
        $('.create_content textarea').val('');
        $('[data-append-to]').prop('selectedIndex', 0);

        filter.trigger('change');

      }
    });     

  });

  /**
   * [ Delete user content ]
   * 
   * Delete user content
   */

  $('[data-action="deletecontent"]').click(function(e) {

    e.preventDefault();

    var val = $(this).data('postid');

    $dropdown = $('[data-append-to]', $(this).parents('.col'));

    $.ajax({
      type: 'POST',
      url: ajaxurl,      
      dataType: 'json',
      data: {
        action : 'delete_report_content',
        postid : val
      },
      success: function(response) {

        $('.create_content').hide();
        $('.create_content textarea').val('');
        $('option:selected', $dropdown).remove();
        $dropdown.prop('selectedIndex', 0);

      }
    });     

  });

  /**
   * [ Single Patient Report ] 
   * 
   * Check is Reference number is numeric
   */

  $('.form--new-report .input-reference, .form--edit-report .input-reference').bind('keypress', function (event) {
    if (event.charCode!=0) {
      var regex = new RegExp('^[0-9]+$');
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        alert('The Reference Number must contain only numbers.');
        return false;
      }
    }
  });



  /**
   * [ Single/archive Patient Report ] 
   * 
   * TimePicker
   */

  $( "#date" ).datepicker({
    dateFormat: 'dd/mm/yy',
    onSelect: function (dateText, inst) {
      $('#searchform-date').submit();
    }
  });

  /**
   * [ Supplement Plans ] 
   * 
   * Add to Plan
   */

  var last_supplement = '';

  $('[data-addtoplan]').click(function(e) { 

    e.preventDefault();

    var brand = $('[name="filter_brand"] option:selected').text(),
        supplement = $('[name="select_supplement"] option:selected').text(),
        dosage = $('[name="dosage"]').val(),
        time = $('[name="time"]').val(),
        user_id = $('[name="user_id"]').val(),
        append = false,
        ed = tinymce.get('plan_text');

    if ( (brand == null) || (supplement == null) || (dosage == null) || (time == null))
    {

      alert('Please select or enter a brand, supplement, dosage and time of day.');

    } else {

      if (last_supplement == (brand + ' ' + supplement))
      {

        ed.selection.select(ed.getBody(), true);
        ed.selection.collapse(false);
        ed.execCommand('mceInsertContent', false, ' and ' + dosage + ' ' + time);

      }
      else
      {
        // if (textarea.val() != '')
        // {
        //   // Only add line breaks if some content already exists
        //   // textarea.val(textarea.val() + '\n\n');
        // }
        ed.selection.select(ed.getBody(), true);
        ed.selection.collapse(false);
        ed.execCommand('mceInsertContent', false, '</p><p>Take ' + dosage + ' of ' + brand + ' ' + supplement + ' ' + time);

      }

      /* Remember the last added supplement for next time */

      last_supplement = brand + ' ' + supplement;

      /* Check if any new brands / supplements have been added and save them to CMS */

      $.ajax({
        type: 'POST',
        url: ajaxurl,      
        dataType: 'json',
        data: {
          action : 'add_brand_supplement',
          brand : brand,
          supplement   : supplement,
          user_id : user_id
        },
        success: function(response) {

        }
      });

    }

  });

  /**
   * [ Create/edit Newsletter ]
   * 
   * 'Search Articles' autocomplete
   */
  
  $('#search, #search_phrase').bind('keypress' , function(e) {
    if (e.which == 13) {
      return false;
    }
  });

  var typingTimeout = 0;

  $('#search, #filter, #search_phrase, [data-filter-search]').on('keyup change', function(e) {

    var type = $(this).data('search');

    if ( $('#search_phrase').length )
    {
      var search_phrase = $('#search_phrase').val();
    }

    var tag = null;

    if ($('[data-filter-search]')) {
      tag = $('[data-filter-search]').val();
    }

    if ($(this).attr('name') == 'filter' && type == 'exercise') {
      $('#exercise_type').find('option:first').attr('selected', 'selected');
    }

    clearTimeout(typingTimeout);

    typingTimeout = setTimeout(function() {

      var search = $('#search');

      $.ajax({
        type: 'POST',
        url: ajaxurl,      
        dataType: 'json',
        data: {
          action : 'search',
          tag : tag,
          type   : type,
          search : search.val(),
          phrase : search_phrase,
        },
        success: function(response) {
          $('#archive .media').remove();  

          if ( $('#search').val() == '' || $('#search').val() == 'all' ) {
            $('.pagination').show();
          } else {
            $('.pagination').hide();
          }

          if (response) {
            $('#noresults').remove();
            $.each(response, function(index, value){  
              if (type == 'article') {        
                $('#archive').append('<div class="media media--newsletter-article" id="' + value.id + '"><div class="media__thumb">' + value.post_thumbnail + '<div class="btn-group"> <a href="' + value.post_thumbnail_url + '" class="btn btn--green" target="_blank"><i class="fa fa-download"></i>Image</a> </div> <div class="btn-group"> <button class="btn btn--green will-load" data-generate-prompt="' + value.id + '" data-tippy-content="Create AI-personalised Version"> <i class="fa fa-cloud"></i> AI Version </button> </div></div><div class="media__body"><h2 class="media__title">' + value.post_title + '</h2><a href="#" data-add="article">Add</a><p>' + value.post_content + ' <a href="' + value.post_permalink + '" target="_blank"><strong>Read more</strong></a></p></div></div>');
              } else if (type == 'recipe') {      
                $('#archive').append('<div class="media media--recipe-article" id="' + value.id + '"><div class="media__thumb">' + value.post_thumbnail + '</div><div class="media__body"><h2 class="media__title">' + value.post_title + '</h2><a href="#" data-add="recipe">Add</a><p>' + value.post_content + ' <a href="' + value.post_permalink + '" target="_blank"><strong>Read more</strong></a></p></div></div>');
              } else {
                $('#archive').append('<div class="media media--exercise-article" id="' + value.id + '"><div class="media__thumb-grid">' + value.image01 + value.image02 + '</div><div class="media__body"><h2 class="media__title">' + value.post_title + '</h2><a href="#" data-add="exercise">Add</a><p>' + value.post_content + ' <a href="' + value.post_permalink + '" target="_blank"><strong>Read more</strong></a></p></div></div>');
              }              
            });
            addArticle();
          } else {
            $('#archive').html('<p id="noresults">Your search didn\'t return any results.</p>');
          }
        }

      });

    }, 250);
    
  });



  /**
   * [ Create/edit Newsletter ]
   * 
   * Pre-written articles pagination
   */
  
  pagination();

  function pagination() {

    $('#js-pagination .page-numbers').on('click', function(e) {
      e.preventDefault();

      // append articles according to pagination
      var href = $(this).attr('href'),
          total_pages = pagination.max_num_pages;    

      $.get(href, function(data) {      
        $('#archive').find('.media').remove();
        $(data).find('#archive .media').appendTo('#archive');
        addArticle();

        $('.pagination').find('.bar').remove();
        $(data).find('.pagination .bar').appendTo('.pagination');
        pagination();
      });

    });

  }




  /**
   * [ Create/edit Newsletter ]
   * 
   * Prevent forms to be submitted on Enter (to avoid submission if searching for articles)
   */

  $('#edit-newsletter, #new-newsletter').keyup(function(e) {
    return e.which !== 13;
  });




  /**
   * [ Create/edit Newsletter ]
   * 
   * Manage articles
   */

  addArticle();
  deleteArticle();



  /**
   * [ Create/edit Newsletter ]
   * 
   * Image preview
   */
  
  $(':file').change(function(){
    var name = $(this).attr('name');
    readURL(this, name);
  });



  /**
   * [ Create/edit Newsletter ]
   * 
   * Repeatable user articles
   */
  
  $('[data-repeater="add-story"]').on('click', function(e){
    e.preventDefault();

    var fieldset = $('fieldset.user-article').last(),
           index = fieldset.data('index');

    var new_fieldset = 
            '<fieldset class="user-article no-border" data-index="' + (index + 1) + '"><div class="form__group"><input type="text" name="newsletter_user_article[title][' + (index + 1) + ']" placeholder="Article title" /> </div> <div class="form__group"> <textarea name="newsletter_user_article[content][' + (index + 1) + ']" cols="30" rows="10" placeholder="Recipe content" data-wysiwyg></textarea> </div> <div class="form__group"> <label for="newsletter_image">Attach an image:</label> <input type="file" name="newsletter_user_article[image][' + (index + 1) + ']" /> </div> </fieldset>'

    $('.user-article:last-of-type').after(new_fieldset);

    $('.user-article:last-of-type :file').change(function(){
      var name = $(this).attr('name');
      readURL(this, name);
    });

    loadWysiwygEditors();

  });

  /**
   * [ Create/edit Food Plan ]
   * 
   * Repeatable user recipes
   */
  
  $('[data-repeater="add-recipe"]').on('click', function(e){
    e.preventDefault();

    var index = $('.user-article').length - 1;

    var new_fieldset = '<fieldset class="user-article no-border" data-index="' + (index + 1) + '"> <div class="form__group"> <input type="text" name="plan_user_article[title][' + (index + 1) + ']" placeholder="Recipe title" /> </div> <div class="form__group"> <textarea name="plan_user_article[content][' + (index + 1) + ']" cols="30" rows="10" placeholder="Recipe content"></textarea> </div> <div class="form__group"> <label for="newsletter_image">Attach an image:</label> <input type="file" name="plan_user_article[image][' + (index + 1) + ']" /> </div> </fieldset>'

    $('.user-article:last-of-type').after(new_fieldset);

    $('.user-article:last-of-type :file').change(function(){
      var name = $(this).attr('name');
      readURL(this, name);
    });

  });


  /**
   * [ General ]
   * 
   * Help section   
   */
  
  $('.help').click(function(){
    $('[data-help]').slideToggle(500);
  });



  /**
   * [ General ]
   * 
   * Alert messages   
   */
  
  function dismissAlert() {
    setTimeout(function(){
      $('.alert--fade').fadeOut(500, function() {
        $(this).remove();
      });
    }, 3000);

    $('[data-close]').click(function(){
      $(this).closest('.alert').fadeOut(500, function() {
        $(this).remove();
      });
    });
  }

  dismissAlert();



  /**
   * [ General ]
   * 
   * Pop ups
   */
  
  $('[data-fire-modal]').on('click', function(e) {
    e.preventDefault();
    var modal = $(this).data('fire-modal');
    $('[data-modal="' + modal + '"]').fadeIn(500, function() {
      $(this).removeClass('is-hidden');
    });
  });

  $('[data-dismiss-modal]').on('click', function(e) {
    e.preventDefault();
    var modal = $(this).data('dismiss-modal');
    $('[data-modal="' + modal + '"]').fadeOut(500, function() {
      $(this).addClass('is-hidden');
    });
  });

  $('.modal').on('click', function(e) {
    if (e.target !== this) return;
    var modal = $(this).data('modal');
    $('[data-modal="' + modal + '"]').fadeOut(500, function() {
      $(this).addClass('is-hidden');
    });
  });

  $(document).keydown(function(event) { 
    if (event.keyCode == 27) { 
      $('.modal:visible').fadeOut(500, function() {
        $(this).addClass('is-hidden');
      });
    }
  });

  /**
   * [ Function ]
   *
   * Add pre-written articles do Newsletter
   */

  function addArticle() {
    $('[data-add]').click(function(e) {
      e.preventDefault();
      var type = $(this).data('add');
      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          action  : 'add_to',
          type    : type, 
          post_id : $(this).parents('.media').attr('id') 
        },
        success: function(response) {
          $('.form__articles-archive').append(response);
          $('.form__articles-archive').find('p').remove();
          $('<div class="alert alert--fade alert--success"><div class="container"><i class="fa fa-check-circle-o"></i>Content has been added to the end of the document <span data-close>&times;</span></div></div>').insertBefore('.content');
          deleteArticle();
          dismissAlert();
          $('.form__articles-archive').next('p').remove();
          loadWysiwygEditors();
        }
      });        

    });
  }



  /**
   * [ Function ]
   *
   * All delete options
   */
  
  function deleteArticle() {
    $('[data-delete]').on('click', function(e) {

      var post_type = $(this).data('delete');

      // Delete Patient Report
      if (post_type == 'report') {
        if (confirm('Are you sure you want to delete this Client Report?') == false) {
          return false;
        } 
      }

      // Delete Report Template
      if (post_type == 'template') {
        if (confirm('Are you sure you want to delete this Template Report?') == false) {
          return false;
        } 
      }

      // Delete Report Template
      if (post_type == 'recipe-sheet') {
        if (confirm('Are you sure you want to delete this Recipe Sheet?') == false) {
          return false;
        } 
      }

      // Delete Newsletter post
      if (post_type == 'newsletter') {
        if (confirm('Are you sure you want to delete this Newsletter?') == false) {
          return false;
        }
      }

      // Delete posts media
      if (post_type == 'exercise-plan-article' || post_type == 'newsletter-article' || post_type == 'newsletter-image' || post_type == 'patient-report') {
        e.preventDefault();
        $(this).closest('.media').fadeOut(500, function(){        
          $(this).remove();
        });
      }

      if ($('.form__articles-archive').children().length == 1) {
        $('.form__articles-archive').delay(500).queue(function(next) {

          if ( post_type == 'exercise-plan-article' ) {
            $(this).after('<p>All copy can be edited to suit your style and saved as your own template. If you wish, you can personalise it for your patient by putting their name in the title and it will appear on their exercise plan.</p>');
          } else {
            $(this).after('<p>Add articles from the pre-written articles list.</p>');
          }
          next();
        });
      }

      // Manage Newsletter articles
      if( $(this).data('delete') == 'newsletter-article' ) {
        var article_id = $(this).closest('.media--form-article').attr('id'),
            unset = $('[name="unset"]');

        if( unset.val() ) {
          var val = unset.val();
          unset.val( val + ', ' + article_id);
        } else {
          unset.val(article_id);
        }
      }

      // Manage Newsletter images
      if( $(this).data('delete') == 'newsletter-image' ) {

        $(this).parents('.form__group').delay(500).queue(function (next) {
          var index = $(this).parent('.user-article').data('index');
          $(this).find('.image_id').remove();          
          $(this).append('<label for="newsletter_image">Attach an image:</label><input type="file" name="newsletter_user_article[image][' + index + ']" />');
          $(':file').change(function(){
            var name = $(this).attr('name');
            readURL(this, name);
          });
          next();
        });
      }

      // Manage PDF header image
      if( $(this).data('delete') == 'user_logo' ) {

        e.preventDefault(); 

        $(this).fadeOut(500, function(){
          $(this).remove();
        });

        $(this).prev('.media').fadeOut(500, function(){
          $(this).remove();
        });
        
        $(':file').remove();

        $(this).parents('.upload-image').delay(500).queue(function (next) {
          $(this).append('<input type="file" name="user_logo" id="user_logo" /><input type="submit" value="Upload" name="upload_user_logo" class="btn btn--green alignright" id="upload_logo">');
          $(':file').change(function(){
            var name = $(this).attr('name');
            readURL(this, name);
          });
          next();
        });

      }

      // Delete patient report Exercise post
      if( $(this).data('delete') == 'patient-report' ) {

        var $exercise_ids = $('[name="exercise_post_ids"]'), 
            patient_report_id = $(this).attr('id'),
            values = $exercise_ids.val().replace(patient_report_id, '');
        
        $exercise_ids.val(values);
      }

    });
  }



  /**
   * [ Function ]
   *
   * Preview image when uploaded
   */
  
  function readURL(input, name) {    
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      
      if (name.indexOf('newsletter_user_article[image]') >= 0) {
        name = 'newsletter-image';
      } else {
        name = name;
      }

      reader.onload = function (e) {
        if (name == 'user_logo') {
          $(input).after('<div class="media media--form-image"><img src="' + e.target.result + '" alt="" /></div><a href="#" class="btn btn--blue" data-delete="' + name + '">Remove logo</a>');
        } else {
          $(input).after('<div class="media media--form-image"><img src="' + e.target.result + '" alt="" /><a href="#" data-delete="' + name + '"><span>Delete</span> <i class="fa fa-times-circle-o"></i></a></div>');
        }
        $(input).prev('label').hide();
        $(input).hide();        
        deleteArticle();
      }
      
      reader.readAsDataURL(input.files[0]);
    }
  }  

});

  /**
   * TinyMCE Editor
   */

   function loadWysiwygEditors() {

    tinyMCE.init({
            selector: '[data-wysiwyg]',
            toolbar1: "bold italic underline bullist numlist",
            menubar: false,
            theme : 'modern',
            skin : 'lightgray',
            elementpath: false,
    });

   }

  $(document).ready(function() { 

    loadWysiwygEditors();

  });


  /**
   * Chosen JS for Tag Select
   */

   $('select.select2').select2({ width : 'element' });

// FB
(function(d, s, id) { var js, fjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) return; js = d.createElement(s); js.id = id; js.src = "//connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v2.0"; fjs.parentNode.insertBefore(js, fjs); } (document, 'script', 'facebook-jssdk'));

// Twitter
!function(d, s, id) { var js, fjs = d.getElementsByTagName(s)[0]; if (!d.getElementById(id)) { js = d.createElement(s); js.id = id; js.src="https://platform.twitter.com/widgets.js"; fjs.parentNode.insertBefore(js,fjs); } } (document,"script","twitter-wjs");



/**
 * New Social Media Layout: December 2019
 */

$('a[data-open-modal="social"]').on('click', function(e) {

  e.preventDefault();

  var modal = $('.modal[data-modal="social"]');
  var tab = $(this).data('tab');
  var content = $(this).parents('.media__social').data('content');

  $('.tabs [data-tab]').each(function() { 

    var channel = $(this).data('tab');

    var share_link = content[channel].link;
    var share_content = content[channel].content;

    if (channel == 'twitter')
    {
      var social_link = 'https://twitter.com/intent/tweet?url=' + share_link + '&text=' + share_content;
    }
    else if (channel == 'facebook')
    {
      var social_link = share_link;
    }

    $('[data-content="content"]', $(this)).html( content[channel].content );
    $('[data-content="link"]', $(this)).attr( 'href', social_link );
    $('[data-content="image"]', $(this)).attr( 'href', content[channel].image );

  });

  // Show active tab

  $('.list--tabs li a[data-tab="' + tab + '"]', modal).click();

  $(modal).removeClass('is-hidden').fadeIn();

});

$('.list--tabs li a').on('click', function(e) {

  e.preventDefault();

  var target = $(this).data('tab');
  var tabs = $(this).parents('.list--tabs').next('.tabs');

  $('div[data-tab]', tabs).hide();
  $('div[data-tab="' + target + '"]', tabs).show();

  $(this).parent('li').siblings('li').removeClass('active');
  $(this).parent('li').addClass('active');

  $(document).on('click', '.btn--fbshare', function() { 
    var share_url = $(this).attr('href');
    fbShare(share_url);
  });

});

function fbShare(url, title, descr, image, winWidth, winHeight) {
    var winTop = (screen.height / 2) - (winHeight / 2);
    var winLeft = (screen.width / 2) - (winWidth / 2);
    var winWidth = 520;
    var winHeight = 350;
    window.open('https://www.facebook.com/sharer/sharer.php?u=' + url , 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
}

/**
 * Customise Mailchimp success message
 */

$(window).on('load', function() {

  if (!document.getElementById('mce-success-response')) return true;

  // select the target node
  var target = document.getElementById('mce-success-response');
  // create an observer instance
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (target.innerHTML === "Thank you for subscribing!") {
        target.innerHTML = "Hope you enjoy the free marketing material";
      }
    });
  });

  // configuration of the observer:
  var config = { attributes: true, childList: true, characterData: true };

  // pass in the target node, as well as the observer options
  observer.observe(target, config);

});

// Copy social content to clipboard

$('[data-copy-social-content]').on('click', function(e) {

  e.preventDefault();

  let button = $(this);

  let copyText = $('.media__content', $(this).parents('.media')).text();
  copyText = $.trim(copyText);

  navigator.clipboard.writeText(copyText);

  button.html('Copied!');

  setTimeout(function() {
    button.html('Copy to Clipboard');
  }, 3000);

});

